import React, { useState } from 'react';
import PackageCard from './PackageCard';
import ActivatePackageModal from '../package/ActivatePackage';
import RetopupModal from '../package/RetopupModal';
import { TOTAL_PACKAGES } from '../../config/contracts';

const PackageGrid = ({ userId, topPackageId, onActivated }) => {
  const [activatePkg, setActivatePkg] = useState(null);
  const [retopupPkg, setRetopupPkg] = useState(null);

  const packages = [];
  for (let i = 1; i <= TOTAL_PACKAGES; i++) {
    const isActive = topPackageId >= i;
    // Locked if the previous package hasn't been activated yet (except for package 1)
    const isLocked = !isActive && i > 1 && topPackageId < i - 1;
    packages.push({ pkgId: i, isActive, isLocked });
  }

  return (
    <>
      <div className="grid grid-auto">
        {packages.map((p) => (
          <PackageCard
            key={p.pkgId}
            pkgId={p.pkgId}
            userId={userId}
            isActive={p.isActive}
            isLocked={p.isLocked}
            onActivate={setActivatePkg}
            onRetopup={p.isActive ? setRetopupPkg : undefined}
          />
        ))}
      </div>

      {activatePkg !== null && (
        <ActivatePackageModal
          packageId={activatePkg}
          onClose={() => setActivatePkg(null)}
          onActivated={() => {
            setActivatePkg(null);
            if (onActivated) onActivated();
          }}
        />
      )}

      {retopupPkg !== null && (
        <RetopupModal
          packageId={retopupPkg}
          userId={userId}
          onClose={() => setRetopupPkg(null)}
          onDone={() => {
            setRetopupPkg(null);
            if (onActivated) onActivated();
          }}
        />
      )}
    </>
  );
};

export default PackageGrid;
